import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=1e2f3221&scoped=true&"
import script from "./SearchBar.vue?vue&type=script&lang=js&"
export * from "./SearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2f3221",
  null
  
)


    import installComponents from "!C:/Projects/rentmagic.website.vue.limburg/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormInput, BButton, BInputGroupAppend, BInputGroup} from 'bootstrap-vue'
    installComponents(component, {BFormInput, BButton, BInputGroupAppend, BInputGroup})
    

export default component.exports